// External Imports
import { h } from 'preact';
import {
  Card,
  Inline,
  ShortText,
  Stack,
  Title,
  pxToRem,
  styled,
} from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Internal Imports
import quoteIcon from '../../assets/images/icons/quote-icon.svg';
import { pxToRemParse } from '../../utils/styles';

// Local Variables
const desktopBreakpoint = pxToRemParse(tokens.viewports.breakpoints.medium);

const QuoteIcon = styled.img`
  height: ${pxToRemParse(tokens.space.x8)};
  width: ${pxToRemParse(tokens.space.x10)};

  @media (min-width: ${desktopBreakpoint}) {
    height: ${pxToRemParse(tokens.space.x8)};
    width: ${pxToRem(44)};
  }
`;

const CardContainer = styled(Card)`
  margin: 0 auto;
  max-width: ${pxToRem(343)};
  @media (min-width: ${desktopBreakpoint}) {
    max-width: ${pxToRem(508)};
  }
`;

// Component Definition
function TestimonialCard({ comment, FlagComponent, learningLanguage, name }) {
  return (
    <CardContainer color="lightened" padding={0}>
      <Stack
        gap={{ medium: pxToRemParse(tokens.space.x8), xxxsmall: pxToRemParse(tokens.space.x4) }}
        padding={{
          medium: [pxToRemParse(tokens.space.x8), pxToRemParse(tokens.space.x12)],
          xxxsmall: [pxToRem(21), pxToRemParse(tokens.space.x8)],
        }}
      >
        <QuoteIcon aria-hidden src={quoteIcon} />
        <Title as="span" size="xsmall">
          {comment}
        </Title>
        <Inline alignItems="center">
          <ShortText>{name}</ShortText>
          <Inline padding={[0, tokens.space.x2]}>
            <FlagComponent height="24" width="24" />
          </Inline>
          <ShortText weight="strong">{learningLanguage}</ShortText>
        </Inline>
      </Stack>
    </CardContainer>
  );
}

// Module Exports
export { TestimonialCard };
